export default __webpack_public_path__ + "static/media/banner-ar_it.cfdf7e8f.png";